import { OnboardingAgentReplyCopyButton } from "./OnboardingAgentReplyCopyButton";
import { OnboardingAgentReplyThumbsDownButton } from "./OnboardingAgentReplyThumbsDownButton";
import { OnboardingAgentReplyThumbsUpButton } from "./OnboardingAgentReplyThumbsUpButton";
import { AssistantFeedbackToolbar } from "./styles";
import { useOnboardingAgentFeedbackToolbar } from "./hooks/useOnboardingAgentFeedbackToolbar";

type OnboardingAgentReplyFeedbackToolbarProps = {
    messageIndex: number;
    copyPlainText: string;
    threadId?: string;
};

export const OnboardingAgentReplyFeedbackToolbar = ({
    messageIndex,
    copyPlainText,
    threadId,
}: OnboardingAgentReplyFeedbackToolbarProps) => {
    const { likeActive, dislikeActive, setLikeActive, setDislikeActive, handleClearLike, handleClearDislike } =
        useOnboardingAgentFeedbackToolbar();

    return (
        <AssistantFeedbackToolbar data-automation={`onboarding-agent-message-${messageIndex}-feedback`}>
            <OnboardingAgentReplyCopyButton
                messageIndex={messageIndex}
                plainText={copyPlainText}
                threadId={threadId}
                dataAutomation={`onboarding-agent-message-${messageIndex}-feedback-copy`}
            />

            <OnboardingAgentReplyThumbsUpButton
                messageIndex={messageIndex}
                isActive={likeActive}
                threadId={threadId}
                onActiveChange={setLikeActive}
                onClearDislike={handleClearDislike}
                dataAutomation={`onboarding-agent-message-${messageIndex}-feedback-up`}
            />

            <OnboardingAgentReplyThumbsDownButton
                messageIndex={messageIndex}
                isActive={dislikeActive}
                threadId={threadId}
                onActiveChange={setDislikeActive}
                onClearLike={handleClearLike}
                dataAutomation={`onboarding-agent-message-${messageIndex}-feedback-down`}
            />
        </AssistantFeedbackToolbar>
    );
};
